import { getRequest } from "src/config/http";
import { Feature } from "../domain/Feature";

export const findFeaturesByProductIdAsync = async (productId: string): Promise<Feature[]> => {
  const response: Array<Record<string, any>> = await getRequest(`/products/${productId}/features`);

  return response.map(json => Feature.fromJson(json));
}